// @flow @format
import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import Select from '../Select';
import ComputerIcon from '../Icon/laptop';

import {encodeEmail} from 'lib/cloner-api/util';

import type {Machine} from 'lib/cloner-api';

type Props = {
	userId: string,
	machine: Machine,
	machines: Machine[],
};

const MachineValue = ({label}) =>
	<span>
		<ComputerIcon style={{fontSize: 'var(--lg-text)'}} />
		{' '}
		{label}
	</span>;

const MachineOption = ({
	focusedOption,
	focusOption,
	key,
	labelKey,
	option,
	selectValue,
	style,
	valueArray,
}) => {
	const className = ['VirtualizedSelectOption'];

	if (option === focusedOption) {
		className.push('VirtualizedSelectFocusedOption');
	}

	if (option.disabled) {
		className.push('VirtualizedSelectDisabledOption');
	}

	if (valueArray && valueArray.indexOf(option) >= 0) {
		className.push('VirtualizedSelectSelectedOption');
	}

	const events = option.disabled
		? {}
		: {
				onClick: () => selectValue(option),
				onMouseOver: () => focusOption(option),
			};

	return (
		<div
			className={className.join(' ')}
			key={key}
			style={style}
			title={option.title}
			{...events}
		>
			<MachineValue {...option} />
		</div>
	);
};

type Option = {
	value: string,
	label: string,
};

const defaultOptions = [];

class MachineSelect extends PureComponent<Props> {
	static contextTypes = {
		router: PropTypes.object.isRequired,
	};

	constructor() {
		super();
		this.handleSelect = this.handleSelect.bind(this);
	}

	handleSelect = (option: Option) => {
		this.context.router.replace(
			`/explorer?machineId=${option.value}&userId=${encodeEmail(
				this.props.userId
			)}`
		);
	};

	render() {
		const {machine, machines} = this.props;

		const loading = !machine;

		let placeholder = 'Selecccione dispositivo';
		if (loading && !machines) {
			placeholder = 'Cargando dispositivos...';
		}

		const options = loading || !machines
			? defaultOptions
			: machines.map(machine => ({
					label: machine.name,
					value: machine.mid,
				}));

		return (
			<Select
				clearable={false}
				optionRenderer={MachineOption}
				valueRenderer={MachineValue}
				placeholder={placeholder}
				options={options}
				value={loading ? null : machine.mid}
				onChange={this.handleSelect}
			/>
		);
	}
}

export default MachineSelect;



// WEBPACK FOOTER //
// ./src/components/MachineSelect/MachineSelect.js